import React from 'react'

import { Button, Card, Flex, InputText } from '@driftt/dds'
import { faClone } from '@driftt/dds.icons/regular/faClone'

import useCopyEmailToClipboard from '../useCopyEmailsToClipboard.hook'

const TableCard = ({ data, children, searchText, setSearchText }) => {
  const { handleCopyEmailToClipboard, isCopied } = useCopyEmailToClipboard(
    data,
    'SALES_REP_TABLE'
  )
  return (
    <Card width="100%">
      <Card.Header>
        <Flex direction="column">
          <Card.Title>
            Who among your organization has yet to finish the following setup
            tasks?
          </Card.Title>
          <Flex fullWidth justifyContent="space-between">
            <InputText
              label="Search sales reps"
              hideLabel
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search sales reps"
            />
            <Button
              variant="tertiary"
              size="medium"
              disabled={!data.length || isCopied}
              onClick={handleCopyEmailToClipboard}
            >
              <Button.Icon icon={faClone} />
              Copy emails
            </Button>
          </Flex>
        </Flex>
      </Card.Header>
      <Card.Content>{children}</Card.Content>
    </Card>
  )
}

export default TableCard
